var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "notifications" },
    [
      _c("div", {
        staticClass: "ui centered inline loader",
        class: { active: _vm.form.waiting },
      }),
      _vm._v(" "),
      _c(
        "dropdown",
        {
          attrs: { placeholder: "すべて" },
          on: {
            change: function ($event) {
              return _vm.search()
            },
          },
          model: {
            value: _vm.form.model.read,
            callback: function ($$v) {
              _vm.$set(_vm.form.model, "read", $$v)
            },
            expression: "form.model.read",
          },
        },
        [
          _c("option", { attrs: { value: "" } }, [_vm._v("すべて")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "false" } }, [_vm._v("未読")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "true" } }, [_vm._v("既読")]),
        ]
      ),
      _vm._v(" "),
      _c("pagination", { attrs: { pager: _vm.pager, callback: _vm.search } }),
      _vm._v(" "),
      _c("table", { staticClass: "ui striped table" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.notifications, function (ntf) {
            return _c("tr", { key: ntf.id }, [
              _c("td", [
                !ntf.read
                  ? _c("span", { staticClass: "ui teal label" }, [
                      _vm._v("未読"),
                    ])
                  : _c("span", { staticClass: "ui label" }, [_vm._v("既読")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "clickable",
                    attrs: { href: ntf.location },
                    on: {
                      click: function ($event) {
                        return _vm.dispatch(ntf)
                      },
                    },
                  },
                  [_vm._v(_vm._s(ntf.title))]
                ),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(_vm._s(_vm._f("formatDatetime")(ntf.created_at))),
              ]),
            ])
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("タイトル")]),
        _vm._v(" "),
        _c("th", [_vm._v("受信日時")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }